(function () {
    var emboPressfeatures = {
        init: function () {
            emboPressfeatures.truncate();
        },
        truncate: function () {
            $('.embo-press-features__text').not("[data-truncate='none']").truncate({
                type: 'text',
                position: 'end',
                lines: 4,
                seeMoreText: '',
                seeLessText: '',
                seeMoreHtml: '',
                ellipsisChar: '&hellip;',
                isMobile: true,
                isSliding: false,
            });
        },
    };
    UX.emboPressfeatures = emboPressfeatures;
    if ($('.embo-press-features').length) {
        UX.emboPressfeatures.init();
    }
})();
